import React, { useState, useEffect } from "react";
import "./index.less";
import { Button, Typography, Form, Input } from "antd";
import { effect } from "../../utils/dva16";
import {
	EPost,
	NLogin,
	EPostUser,
	EPostPassWordReset,
} from "../../models/contants";
import headerImg from "../../assets/header.png";
import footerImg from "../../assets/footer.png";
import FindPassWord from "../Login/component/FindPassWord";
import NewUser from "../Login/component/NewUser";
const { Link } = Typography;
import { RightOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";

export default (props) => {
	const { history } = props;
	const [visible, setVisible] = useState(false); //控制找回密码弹窗 | Control Retrieve Password Popup
	const [Registervisible, setregisterVisible] = useState(false); //控制用户注册弹窗 | Control User Registration Popup
	const isSmallScreen = useMediaQuery({ maxWidth: 768 });

	const onFinish = (values) => {
		effect(NLogin, EPost, values, () => {
			history.replace("/");
		});
	};
	const onSignUp = (values) => {
		setregisterVisible(true);
	};
	const onFind = () => {
		history.push("/ForgetPassword");
	};
	return (
		<div className="loginContainer">
			<div className="LoginBox">
				<img src={headerImg} className="headerimg" />
				<div className="LoginFormBox">
					<Form name="login" onFinish={onFinish} autoComplete="off">
						<Form.Item
							name="email"
							rules={[
								{
									required: true,
									message: "Please enter Email Address",
								},
								{
									type: "email",
									message: "The input is not valid E-mail!",
								},
							]}
						>
							<Input
								className="inputLogin"
								placeholder="Email Address"
								style={{ width: "100%", height: "50px !important" }}
							/>
						</Form.Item>

						<Form.Item
							name="password"
							rules={[{ required: true, message: "Please enter Password" }]}
							// style={{ marginTop: "3rem" }}
						>
							<Input.Password
								placeholder="Password"
								className="inputLogin"
								visibilityToggle={true}
								style={{
									width: "100%",
									alignItems: "center",
									height: "50px !important",
								}}
							/>
						</Form.Item>

						<Form.Item className="Login_Btn_Label">
							<Button
								type="primary"
								size="large"
								htmlType="submit"
								className="Login_Btn_Box"
							>
								Login
							</Button>

							<span className="forget" onClick={onFind}>
								Forgot Password?
							</span>
						</Form.Item>
					</Form>
				</div>
				<div className="footer">
					<a
						href="https://nikopartners.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src={footerImg}
							alt=""
							style={{ width: "128px", height: "30px" }}
						/>
					</a>
					<div>
						<div className="whiteTxt">
							Contact:{" "}
							<Link className="linkItem" href="mailto:support@nikopartners.com">
								support@nikopartners.com
							</Link>
						</div>

						<div className="whiteTxt">
							<Link
								className="linkItem"
								onClick={() => history.push("/term_and_conditions")}
								target="_blank"
								rel="noopener noreferrer"
							>
								Terms and conditions
							</Link>{" "}
							|{" "}
							<Link
								className="linkItem"
								onClick={() => history.push("/privacy_policy")}
								target="_blank"
								rel="noopener noreferrer"
							>
								Privacy policy
							</Link>{" "}
						</div>
					</div>
				</div>
			</div>
			<FindPassWord
				className="find_Password"
				title={`Retrieve Password`}
				centered
				width={800}
				visible={visible}
				footer={null}
				onCancel={() => {
					setVisible(false);
				}}
				onOk={(payload) => {
					setVisible(false);
					effect(NLogin, EPostPassWordReset, payload, () => {});
				}}
			/>
			<NewUser
				className="new_User"
				title={`Sign Up`}
				centered
				width={800}
				footer={null}
				visible={Registervisible}
				onCancel={() => {
					setregisterVisible(false);
				}}
				onOk={(payload) => {
					effect(NLogin, EPostUser, payload, () => {
						setregisterVisible(false);
					});
				}}
			/>
		</div>
	);
};
